/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to notify conversation participants
 * @export
 * @interface NotifyParticipantsRequest
 */
export interface NotifyParticipantsRequest {
    /**
     * UUID generated by the frontend to correlate API requests with websocket messages (prevents duplicate notifications)
     * @type {string}
     * @memberof NotifyParticipantsRequest
     */
    correlationUuid: string;
}

/**
 * Check if a given object implements the NotifyParticipantsRequest interface.
 */
export function instanceOfNotifyParticipantsRequest(value: object): value is NotifyParticipantsRequest {
    if (!('correlationUuid' in value) || value['correlationUuid'] === undefined) return false;
    return true;
}

export function NotifyParticipantsRequestFromJSON(json: any): NotifyParticipantsRequest {
    return NotifyParticipantsRequestFromJSONTyped(json, false);
}

export function NotifyParticipantsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotifyParticipantsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'correlationUuid': json['correlation_uuid'],
    };
}

export function NotifyParticipantsRequestToJSON(json: any): NotifyParticipantsRequest {
    return NotifyParticipantsRequestToJSONTyped(json, false);
}

export function NotifyParticipantsRequestToJSONTyped(value?: NotifyParticipantsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'correlation_uuid': value['correlationUuid'],
    };
}

